import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Box,
} from "@mui/material";
import { IconButton } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { loanAccountL2Data } from "../assets/loanAccountL2";
import { useClientContext } from "../context/ClientContext";
import { clientGroups } from "../assets/clientData";
import { useState, useEffect } from "react";
import { formatCurrency } from "../utils/helper";

const LoanAccountsTable = ({ setLevel }) => {
  const { clientName, clientGroup } = useClientContext();
  const [filteredData, setFilteredData] = useState([]);
  const currentDate = new Date().toLocaleDateString();

  useEffect(() => {
    const filtered = loanAccountL2Data.filter(
      (data) =>
        data.company_name === clientName &&
        data.group_company ===
          clientGroups.find((group) => group.group_name === clientGroup)?.label
    );
    console.log("filtered", filtered);
    setFilteredData(filtered);
  }, [clientName, clientGroup]);


  const handleProductHoldings = (level) => {
    setLevel(level);
  };

  return (
    <Box
      className="rounded-md py-2 px-4"
      style={{
        boxShadow: "0px 2px 20px rgba(0, 0, 0, 0.1)",
        height: "60vh",
      }}
    >
      <div className="flex justify-between items-center mr-2">
        <IconButton
          aria-label="<>"
          sx={{ height: 24, width: 24 }}
          onClick={() => handleProductHoldings("L1")}
        >
          <ArrowBackIcon sx={{ fontSize: 16 }} />
        </IconButton>

        <IconButton
          aria-label="<>"
          sx={{ height: 24, width: 24 }}
          onClick={() => handleProductHoldings("L3")}
        >
          <ArrowForwardIcon sx={{ fontSize: 16 }} />
        </IconButton>
      </div>
      <div className="font-bold text-left text-xs pb-2 my-2 mx-2">
        Loan Accounts
      </div>
      <div
        className="overflow-auto mx-2"
        style={{ maxHeight: "calc(60vh - 80px)" }}
      >
        <TableContainer component={Paper}>
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                ></TableCell>
                <TableCell
                  align="center"
                  colSpan={2}
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Current FY (as of {currentDate})
                </TableCell>
                <TableCell
                  align="center"
                  colSpan={2}
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Last FY
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                ></TableCell>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Limit
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Outstanding
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Limit
                </TableCell>
                <TableCell
                  align="center"
                  sx={{
                    backgroundColor: "#00555C",
                    color: "white",
                    fontSize: "0.75rem",
                  }}
                >
                  Outstanding
                </TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredData.map((row, index) => (
                <TableRow
                  key={index}
                  sx={{
                    backgroundColor: "white",
                    "&:last-child td, &:last-child th": { border: 0 },
                  }}
                >
                  <TableCell
                    sx={{
                      paddingLeft: "16px",
                      fontSize: "0.75rem",
                    }}
                  >
                    {row.product_name}
                    
                  </TableCell>
                  <TableCell align="center" sx={{ fontSize: "0.75rem" }}>
                    {formatCurrency(row.product_level_credit_limit)}
                  </TableCell>
                  <TableCell align="center" sx={{ fontSize: "0.75rem" }}>
                    {formatCurrency(row.product_level_credit_outstanding)}

                  </TableCell>
                  <TableCell align="center" sx={{ fontSize: "0.75rem" }}>
                    ...
                  </TableCell>
                  <TableCell align="center" sx={{ fontSize: "0.75rem" }}>
                    ...
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      </div>
    </Box>
  );
};

export default LoanAccountsTable;
